import { render, staticRenderFns } from "./StartConversationNewSeller.vue?vue&type=template&id=e11b5246&scoped=true"
import script from "./StartConversationNewSeller.vue?vue&type=script&lang=js"
export * from "./StartConversationNewSeller.vue?vue&type=script&lang=js"
import style0 from "./StartConversationNewSeller.vue?vue&type=style&index=0&id=e11b5246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11b5246",
  null
  
)

export default component.exports